import React from "react";
import PhoneInput from "react-phone-input-2";
import { callApi, validateToken } from "../../lib/utils";
import { parsePhoneNumber } from 'libphonenumber-js';
import axios from "axios";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { Row, Col, Form, Card, Button, Modal, Spinner } from "react-bootstrap";
import { css } from "aphrodite";
import SideDetails from "../GenericComponents/SideDetails";
import SideMenuComponentsHeader from "../GenericComponents/Headers/SideMenuComponentsHeader";
import CustomLoader from "../GenericComponents/CustomLoader";
import CustomModal from "../GenericComponents/AdminPortal/CustomModal";
import GenericModal from "../GenericComponents/CustomModal";
import NewContactModal from "./NewContactModal";
import styles from "./style";
import "./PatientContacts.css";

const PORTAL_ACCESS_TYPES = ["FAMILY", "FRIEND", "CARE_GIVER"];

class PatientContacts extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      validated: true,
      typeWiseContacts: {},
      patientContactTypes: [],
      patientContactData: {},
      showNewContactModal: false,
      imageArr: [],
      loading: false,
      contactTypeParams: {},
      showDeleteModal: false,
      title: "",
      modalType: 0,
      showCustomModal: false,
      customMessage: "",
      patientContactId: 0,
      patientContactList: [],
      contactPhoto: [],
      subsPlanName: "",
      totalCallAlerts: 0,
      totalSMSAlerts: 0,
      showAlertPopup: false,
      isValidPhone: false,
      selectedContact: null,
      inviteLoading: false,
      permissionsEmail: '',
      inviteStatus: null,
      emailError: '',
      inviteSent: false,
      showManagePermissionsModal: false,
      isEditingInviteEmail: false,
      isEmailDisabled: false,
      formInputs: {
        contactImage: [],
        firstName: "",
        lastName: "",
        phone: "",
        email: "",
        //otherName: "",
        contactType: "",
        enableEmergencyCallOpt: false,
        enableTextMessageOpt: false,
        enablePrescriptionMedsOpt: false,
        enableGeoFenceAlertOpt: false,
        enableBatteryStatusAlertOpt: false,
        sendPortalInvite: false // Add this
      },
      formValidations: {
        contactType: {
          required: true,
        },
        phone: {
          required: false,
        },
        firstName: {
          required: false,
        },
        lastName: {
          required: false,
        },
        email: {
          required: false,
        },
        enableEmergencyCallOpt: {
          required: false,
        },
        enableTextMessageOpt: {
          required: false,
        },
        enablePrescriptionMedsOpt: {
          required: false,
        },
        enableGeoFenceAlertOpt: {
          required: false,
        },
        enableBatteryStatusAlertOpt: {
          required: false
        },
        contactImage: {
          required: false,
        },

        sendPortalInvite: {
          required: false,
        },
      }
    };
  }

  componentDidMount = () => {
    validateToken((err) => {
      if (err) {
        window.location = "/logout";
      }
      this.fetchContactTypes();
      this.fetchSubscriptionDetail();
    });
  };

  fetchContactTypes = () => {
    this.setState({ loading: true });
    callApi(`/api/patient/contact/type`, {}, "GET")
      .then((response) => {
        let contactTypes = response.data.data.contactTypes;
        let patientContactTypes = contactTypes;
        patientContactTypes.map((val) => {
          val.name = val.contactType;
          return val;
        });
        this.setState({ patientContactTypes }, () => {
          this.fetchContacts();
        });
        //this.props.history.push("/dashboard");
      })
      .catch((err) => {
        //console.log("err: ", err);
        this.setState({
          loading: false,
        });
      });
  };

  fetchSubscriptionDetail = () => {
    this.setState({ loading: true });
    validateToken((err) => {
      if (err) {
        window.location = "/logout";
      }
      callApi(
        `/api/patient/subscription`,
        {},
        "GET"
      )
        .then((response) => {
          let subsPlanName = response.data.data.patientSubscription.subscriptionPlan.planName;
          this.setState({ subsPlanName, loading: false });
          //this.props.history.push("/dashboard");
        })
        .catch((err) => {
          //console.log("err: ", err);
          this.setState({
            loading: false,
          });
        });
    });
  };

  fetchContacts = () => {
    validateToken((err) => {
      if (err) {
        window.location = "/logout";
      }
      callApi(
        `/api/web/patient/contacts/list`,
        {},
        "GET"
      )
        .then((response) => {
          let patientContacts = response.data.data.contacts;
          let totalCallAlerts = 0;
          let totalSMSAlerts = 0;
          patientContacts.forEach((val) => {
            if (val.emergencyCall)
              totalCallAlerts++;
            if (val.enabledForText)
              totalSMSAlerts++;
          })
          let typeWiseContacts = {};
          this.state.patientContactTypes.forEach((type) => {
            typeWiseContacts[type.code] = patientContacts
              .filter((val) => {
                return val.contactType.code === type.code;
              })
              .map((contacts) => {
                return contacts;
              });
          });

          var self = this;
          let imageArr = [];
          this.fetchContactImage(patientContacts, function (response) {
            imageArr.push(response);
            self.setState({ imageArr });
          });
          this.setState({ typeWiseContacts, patientContactList: patientContacts, totalCallAlerts, totalSMSAlerts, loading: false });
          //this.props.history.push("/dashboard");
        })
        .catch((err) => {
          //console.log("err: ", err);
          this.setState({
            loading: false,
          });
        });
    });
  };

  fetchContactImage = (contacts, callback) => {
    validateToken((err) => {
      if (err) {
        window.location = "/logout";
      }
      contacts.map((contact) => {
        axios({
          url: `/api/web/patient/contacts/image/fetch/${contact.id}`,
          method: "GET",
          responseType: "blob",
        })
          .then((response) => {
            if (response.status === 200) {
              this.getBase64(response.data).then((result) => {
                let imageObj = {};
                imageObj.id = contact.id;
                imageObj.path = result;
                callback(imageObj);
              });
            }
          })
          .catch((err) => {
            //console.log(err);
            this.setState({
              loading: false,
            });
          });
      });
    });
  };

  getBase64 = (file) => {
    return new Promise((resolve) => {
      let baseURL = "";
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        baseURL = reader.result;
        resolve(baseURL);
      };
    });
  };

  updateContact = (contact) => {
    var self = this;
    let contactPhoto = [];
    let contacts = [{ ...contact }];
    if (contact.contactImage !== null) {
      this.fetchContactImage(contacts, function (res) {
        res.file = null;
        contactPhoto.push(res);
        self.setState({ contactPhoto }, () => {
          self.handleUpdate(contact);
        });
      });
    } else {
      this.handleUpdate(contact);
    }
  };

  handleUpdate = (contact) => {
    let formInputs = { ...this.state.formInputs };
    let formValidations = { ...this.state.formValidations };
    formInputs.sendPortalInvite = false; // Reset for update flow
    formInputs.contactImage = this.state.contactPhoto;
    formInputs.contactType = contact.contactTypeId;
    formInputs.firstName = contact.firstName;
    formInputs.lastName = contact.lastName;
    formInputs.email = contact.email;
    formInputs.phone = contact.phoneNumber;
    formInputs.enableEmergencyCallOpt = contact.emergencyCall;
    formInputs.enableTextMessageOpt = contact.enabledForText;
    formInputs.enablePrescriptionMedsOpt = contact.notifyPrescriptionMeds;
    formInputs.enableGeoFenceAlertOpt = contact.enableGeoFenceAlert;
    formInputs.enableBatteryStatusAlertOpt = contact.enableBatteryStatusAlert;

    let tempContactTypeParams = this.state.patientContactTypes.filter((val) => {
      return val.id === contact.contactTypeId;
    });
    tempContactTypeParams.length !== 0 && Object.keys(tempContactTypeParams[0].fieldsValidation).forEach((val) => {
      formValidations[val] = tempContactTypeParams[0].fieldsValidation[val];
    })
    const isEmailDisabled = !!contact.email && contact.caregiverStatus !== null;
    this.setState(
      {
        formInputs,
        formValidations,
        title: "Edit Contact",
        modalType: 2,
        patientContactId: contact.id,
        contactTypeParams: tempContactTypeParams[0],
        showNewContactModal: !this.state.showNewContactModal,
        validated: false,
        isValidPhone: true,
        isEmailDisabled
      }
    );
  };

  addNewContact = () => {
    this.setState(
      {
        title: "New Contact",
        modalType: 1,
        showNewContactModal: !this.state.showNewContactModal,
      }
    );
  };

  handleAlertPopup = () => {
    this.setState({
      showAlertPopup: !this.state.showAlertPopup,
    });
  };

  closeNewContactModal = () => {
    let formInputs = { ...this.state.formInputs };
    formInputs.contactImage = [];
    formInputs.contactType = "";
    formInputs.firstName = "";
    formInputs.lastName = "";
    formInputs.email = "";
    formInputs.phone = "";
    formInputs.enableEmergencyCallOpt = false;
    formInputs.enableTextMessageOpt = false;
    formInputs.enablePrescriptionMedsOpt = false;
    formInputs.enableGeoFenceAlertOpt = false;
    formInputs.enableBatteryStatusAlertOpt = false;
    formInputs.sendPortalInvite = false;
    this.setState({
      formInputs,
      validated: true,
      isValidPhone: false,
      contactTypeParams: {},
      //imageArr: [],
      contactPhoto: [],
      showNewContactModal: !this.state.showNewContactModal,
      isEmailDisabled: false,
    });
  };

  handleChange = (e) => {
    let fieldName = e.target.name;
    let fieldValue = e.target.value;
    let formInputs = { ...this.state.formInputs };
    let formValidations = { ...this.state.formValidations };

    let tempContactTypeParams = [{ ...this.state.contactTypeParams }];

    if (fieldName === "contactType") {
      tempContactTypeParams = this.state.patientContactTypes.filter((val) => {
        return val.id === parseInt(fieldValue);
      });
      tempContactTypeParams.length !== 0 && Object.keys(tempContactTypeParams[0].fieldsValidation).forEach((val) => {
        formValidations[val] = tempContactTypeParams[0].fieldsValidation[val];
      })
    }
    formInputs[fieldName] = fieldValue;
    this.setState({
      formInputs,
      formValidations,
      contactTypeParams:
        tempContactTypeParams.length !== 0 ? tempContactTypeParams[0] : {},
    }, () => {
      this.setValidated(formInputs);
    });
  };

  setValidated = (formInputs) => {
    let validated = false;
    let formValidations = { ...this.state.formValidations };

    for (let fieldName in formInputs) {
      let validationObj = formValidations[fieldName];
      let val = "";
      if (formInputs[fieldName] !== null)
        val = formInputs[fieldName].toString();

      if (validationObj.required && val.trim() === "") {
        validated = true;
        break;
      }
    }

    this.setState({ validated })
  };

  setPhoneNumber = (data, country) => {
    let formInputs = { ...this.state.formInputs };
    formInputs["phone"] = data;
    let isValidPhone = this.phoneValidation(data, country);

    this.setState({
      formInputs,
      isValidPhone
    });
  };

  phoneValidation = (value, country) => {
    try {
      let parsedPhoneNumber = parsePhoneNumber(`+${value}`, country.countryCode.toUpperCase());
      if (parsedPhoneNumber.isValid()) {
        return true;
      } else {
        return false;
      }
    } catch (e) {
      console.log("Parsing Error: ", e.message);
    }
  }

  handleEmergencyCall = () => {
    let formInputs = { ...this.state.formInputs };
    let showAlertPopup = false;
    //console.log("totalCallAlerts...", this.state.totalCallAlerts);
    //console.log("enableEmergencyCallOpt...", formInputs.enableEmergencyCallOpt);
    let editContactData = this.state.patientContactList.find(val => val.id === this.state.patientContactId)

    if (this.state.modalType === 2 && editContactData.emergencyCall)
      formInputs.enableEmergencyCallOpt = !formInputs.enableEmergencyCallOpt;
    else if (this.props.contactAlertLimit)
      if (!formInputs.enableEmergencyCallOpt && this.props.contactAlertLimit <= this.state.totalCallAlerts)
        showAlertPopup = true;
      else
        formInputs.enableEmergencyCallOpt = !formInputs.enableEmergencyCallOpt;
    else
      formInputs.enableEmergencyCallOpt = !formInputs.enableEmergencyCallOpt;

    this.setState({ formInputs, showAlertPopup });
  };

  handleTextMessage = () => {
    let formInputs = { ...this.state.formInputs };
    let showAlertPopup = false;

    let editContactData = this.state.patientContactList.find(val =>
      val.id === this.state.patientContactId
    )

    if (this.state.modalType === 2 && editContactData.enabledForText)
      formInputs.enableTextMessageOpt = !formInputs.enableTextMessageOpt;
    else if (this.props.contactAlertLimit)
      if (!formInputs.enableTextMessageOpt && this.props.contactAlertLimit <= this.state.totalSMSAlerts)
        showAlertPopup = true;
      else
        formInputs.enableTextMessageOpt = !formInputs.enableTextMessageOpt;
    else
      formInputs.enableTextMessageOpt = !formInputs.enableTextMessageOpt;

    this.setState({ formInputs, showAlertPopup });
  };

  handlePrescriptionMeds = () => {
    let formInputs = { ...this.state.formInputs };
    formInputs.enablePrescriptionMedsOpt =
      !formInputs.enablePrescriptionMedsOpt;
    this.setState({ formInputs });
  };

  handleGeoFenceAlert = () => {
    let formInputs = { ...this.state.formInputs };
    formInputs.enableGeoFenceAlertOpt =
      !formInputs.enableGeoFenceAlertOpt;
    this.setState({ formInputs });
  };

  handleBatteryPerAlert = () => {
    let formInputs = { ...this.state.formInputs };
    formInputs.enableBatteryStatusAlertOpt =
      !formInputs.enableBatteryStatusAlertOpt;
    this.setState({ formInputs });
  };

  submitContactData = (e) => {
    e.preventDefault();
    let formInputs = { ...this.state.formInputs };
    let params = {
      contactTypeId: parseInt(formInputs.contactType),
      firstName: formInputs.firstName,
      lastName: formInputs.lastName,
      phoneNumber: `+${formInputs.phone}`,
      email: formInputs.email,
      emergencyCall: formInputs.enableEmergencyCallOpt,
      enabledForText: formInputs.enableTextMessageOpt,
      notifyPrescriptionMeds: formInputs.enablePrescriptionMedsOpt,
      enableGeoFenceAlert: formInputs.enableGeoFenceAlertOpt,
      enableBatteryStatusAlert: formInputs.enableBatteryStatusAlertOpt,
      sendPortalAccessInvite: formInputs.sendPortalInvite
    };

    this.setState({ loading: true });
    validateToken((err) => {
      if (err) {
        window.location = "/logout";
      }
      callApi(
        `/api/web/patient/contacts`,
        params,
        "POST"
      )
        .then((response) => {
          if (response.status === 200) {
            this.setState({ loading: false }, () => {
              this.submitContactImage(response.data.data.contact);
            });
          }
          //this.props.history.push("/dashboard");
        })
        .catch((err) => {
          //console.log("err: ", err.statusCode);
          this.setState({
            showCustomModal: true,
            loading: false,
            customMessage:
              err.statusCode !== 500 ? err.message : "something went wrong!",
          });
        });
    });
  };

  updateContactData = (e) => {
    e.preventDefault();
    let formInputs = { ...this.state.formInputs };
    let params = {
      contactTypeId: parseInt(formInputs.contactType),
      firstName: formInputs.firstName,
      lastName: formInputs.lastName,
      phoneNumber: `+${formInputs.phone}`,
      email: formInputs.email,
      emergencyCall: formInputs.enableEmergencyCallOpt,
      enabledForText: formInputs.enableTextMessageOpt,
      notifyPrescriptionMeds: formInputs.enablePrescriptionMedsOpt,
      enableGeoFenceAlert: formInputs.enableGeoFenceAlertOpt,
      enableBatteryStatusAlert: formInputs.enableBatteryStatusAlertOpt
    };
    this.setState({ loading: true });
    validateToken((err) => {
      if (err) {
        window.location = "/logout";
      }
      callApi(
        `/api/web/patient/contacts/${this.state.patientContactId}`,
        params,
        "PUT"
      )
        .then((response) => {
          if (response.status === 200) {
            this.setState({ loading: false }, () => {
              this.submitContactImage(response.data.data.contact);
            });
          }

          //this.props.history.push("/dashboard");
        })
        .catch((err) => {
          this.setState({
            showCustomModal: true,
            loading: false,
            customMessage:
              err.statusCode !== 500 ? err.message : "something went wrong!",
          });
        });
    });
  };

  openDeleteModal = (contact) => {
    let element = (
      <div>
        <Modal.Header closeButton>
          <Modal.Title>Confirm</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Do you want to delete the contact <b>{contact.firstName}</b> ?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => this.handleDeleteClose()}>
            No
          </Button>
          <Button variant="primary" onClick={() => this.deleteContact(contact)}>
            Yes
          </Button>
        </Modal.Footer>
      </div>
    );

    this.setState({
      showDeleteModal: !this.state.showDeleteModal,
      element,
    });
  };

  deleteContact = (contact) => {
    this.setState({ loading: true });
    validateToken((err) => {
      if (err) {
        window.location = "/logout";
      }
      callApi(
        `/api/web/patient/contacts/${contact.id}`,
        {},
        "Delete"
      )
        .then((response) => {
          this.setState({ loading: false, showCustomModal: true, customMessage: "contact deleted successfully !" }, () => {
            this.handleDeleteClose();
            this.fetchContacts();
          });

          //this.props.history.push("/dashboard");
        })
        .catch((err) => {
          this.handleDeleteClose();
          this.setState({
            showCustomModal: true,
            loading: false,
            customMessage:
              err.statusCode !== 500 ? err.message : "something went wrong!",
          });
        });
    });
  };

  handleCustomModal = () => {
    this.setState({ showCustomModal: false });
  };



  handleSendInviteToggle = () => {
    const { formInputs } = this.state;

    // If user is trying to check the box (currently false)
    if (!formInputs.sendPortalInvite) {
      if (!formInputs.email || !this.validateEmail(formInputs.email)) {
        this.setState({
          showCustomModal: true,
          customMessage: "Please enter a valid email address to enable portal access invitation."
        });
        return;
      }
    }

    this.setState({
      formInputs: {
        ...formInputs,
        sendPortalInvite: !formInputs.sendPortalInvite
      }
    });
  };

  handleDeleteClose = () => {
    this.setState({ showDeleteModal: !this.state.showDeleteModal });
  };

  handleContactImage = (imageList, addUpdateIndex) => {
    // data for submit
    //console.log(imageList, addUpdateIndex);
    let formInputs = { ...this.state.formInputs };
    formInputs.contactImage = imageList;
    this.setState({ formInputs });
  };

  validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  };

  handleEmailChange = (e) => {
    this.setState({
      permissionsEmail: e.target.value,
      emailError: ''
    });
  };

  handleEditInviteEmail = () => {
    this.setState({
      inviteStatus: null,
      inviteSent: false,
      emailError: '',
      isEditingInviteEmail: true
    });
  };

  handleOpenPermissions = (contact) => {
    this.setState({
      showManagePermissionsModal: true,
      selectedContact: contact,
      permissionsEmail: contact.email || '',
      inviteStatus: contact.caregiverStatus || null,
      emailError: '',
      inviteSent: false,
      isEditingInviteEmail: false
    });
  };

  handleClosePermissions = () => {
    this.setState({ showManagePermissionsModal: false, selectedContact: null });
  };

  handlePortalAction = (actionType, isEditingInviteEmail) => {
    const { selectedContact, permissionsEmail } = this.state;
    // For Updating the email
    if (isEditingInviteEmail) {
      // Prevent updating to the same email
      if (selectedContact && selectedContact.email && selectedContact.email === permissionsEmail) {
        this.setState({
          emailError: 'Please provide an updated email'
        });
        return;
      }

      this.setState({ inviteLoading: true, emailError: '' });

      callApi(`/api/web/caregiver/update-email/${selectedContact.id}`, { email: permissionsEmail }, 'PATCH')
        .then((res) => {
          const message =
            (res && res.message) ||
            (res && res.data && (res.data.message || res.data.msg)) ||
            'Email updated successfully';

          this.setState(
            {
              inviteLoading: false,
              inviteSent: false,
              showCustomModal: true,
              customMessage: message,
              isEditingInviteEmail: false
            },
            () => {
              this.handleClosePermissions();
              this.fetchContacts();
            }
          );
        })
        .catch((err) => {
          console.log(err);
          this.setState({
            inviteLoading: false,
            showCustomModal: true,
            customMessage: err.statusCode !== 500 ? err.message : 'something went wrong!'
          });
        });
      return;
    }

    // For REVOKE action, use DELETE method
    if (actionType === 'REVOKE') {
      this.setState({ inviteLoading: true });

      callApi(`/api/web/patient/contacts/portal-access/${selectedContact.id}`, {}, 'DELETE')
        .then(res => {
          this.setState({
            inviteLoading: false,
            inviteSent: false
          });
          this.fetchContacts();
          this.handleClosePermissions();
        })
        .catch(err => {
          console.log(err);
          this.setState({
            inviteLoading: false,
            showCustomModal: true,
            customMessage: err.statusCode !== 500 ? err.message : "something went wrong!"
          });
        });
      return;
    }

    // For other actions (SEND, RESEND, REINVITE), validate email and use POST
    if (!selectedContact.email && !this.validateEmail(permissionsEmail)) {
      this.setState({ emailError: 'Please enter a valid email address' });
      return;
    }

    this.setState({ inviteLoading: true });

    const payload = {
      email: permissionsEmail,
    };

    callApi(`/api/web/patient/contacts/portal-access/${selectedContact.id}`, payload, 'POST')
      .then(res => {
        this.setState({
          inviteLoading: false,
          inviteSent: true
        });
        this.fetchContacts();
      })
      .catch(err => {
        console.log(err);
        this.setState({
          inviteLoading: false, inviteSent: false, showCustomModal: true,
          customMessage: err.statusCode !== 500 ? err.message : "something went wrong!"
        });
        // Fallback for demonstration purposes
      });
  };

  submitContactImage = (contact) => {
    let formData = new FormData(); //formdata object
    let url = `/upload/web/patient/contacts/image/${contact.id}`;
    validateToken((err) => {
      if (err) {
        window.location = "/logout";
      }
      if (this.state.formInputs.contactImage.length !== 0 && this.state.formInputs.contactImage[0].file !== null) {
        formData.append(
          "profileImage",
          this.state.formInputs.contactImage[0].file
        ); //append the values with key, value pair

        const config = {
          headers: { "Content-Type": "multipart/form-data" },
        };

        axios
          .post(url, formData, config)
          .then((response) => {
            this.setState({ loading: false, showCustomModal: true, customMessage: this.state.modalType === 1 ? "contact saved successfully !" : "contact updated successfully !" }, () => {
              this.closeNewContactModal();
              this.fetchContacts();
            });
          })
          .catch((err) => {
            this.setState({
              showCustomModal: true,
              loading: false,
              customMessage:
                err.statusCode !== 500 ? err.message : "something went wrong!",
            });
          });
      } else {
        this.setState({ loading: false, showCustomModal: true, customMessage: this.state.modalType === 1 ? "contact saved successfully !" : "contact updated successfully !" }, () => {
          this.closeNewContactModal();
          this.fetchContacts();
        })
      }
    });
  };

  shouldShowCRUDOptions(isSharedContact = false) {
    if (isSharedContact) return false;

    const { user, appModules } = this.props;

    if (user.isSubscriptionApplicable && appModules.active.CONT) return true;
    else if ((!user.isSubscriptionApplicable) && appModules.active.CONT) return true;
    return false;
  }
  render() {
    const { showManagePermissionsModal, permissionsEmail, inviteStatus, emailError, inviteSent, selectedContact, inviteLoading, isEditingInviteEmail } = this.state;
    const isEmailFixed = selectedContact && !!selectedContact.email && !isEditingInviteEmail;
    const { user } = this.props;
    // Check if user is caregiver for Read-Only mode
    const isReadOnly = user?.roleId === 10;

    return (
      <container>
        <CustomLoader loading={this.state.loading} />
        {/* Manage Permissions Modal */}
        <Modal show={showManagePermissionsModal} onHide={this.handleClosePermissions} centered size="lg" backdrop="static">
          <Modal.Header closeButton style={{ borderBottom: 'none' }}>
            <Modal.Title style={{ fontSize: '20px', fontWeight: 'bold' }}>
              MANAGE PORTAL ACCESS INVITATIONS
            </Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ padding: '0 30px 30px 30px' }}>
            <div className="mb-4">
              {/* <h6 style={{ fontWeight: 'bold', color: '#333', marginBottom: '10px' }}>PORTAL ACCESS</h6> */}
              <p style={{ fontSize: '17px', marginBottom: '5px' }}>
                Invite this contact to access your Acuma Health user portal with read only permissions.
              </p>
              <p style={{ fontSize: '15px', color: 'rgb(106 100 100)' }}>
                Caregivers can view events, monitoring settings, and payment methods but can not make changes.
              </p>
            </div>
            {inviteSent ? (
              <div className={css(styles.permissionsContainer)}>
                <div className={css(styles.successHeader)}>
                  <i className="fa fa-check-circle mr-2" style={{ color: 'green' }}></i>
                  {" "}Invitation successfully sent to <strong>{permissionsEmail}</strong> on <strong>{new Date().toLocaleString()}</strong>
                </div>
              </div>
            ) :
              inviteStatus === null ? (
                <>
                  <Form.Group controlId="portalInviteEmail">
                    <Form.Label className="small font-weight-bold" style={{ color: '#666' }}>Contact Email</Form.Label>
                    <div style={{ display: 'flex', gap: "10px" }}>
                      <Form.Control
                        type="email"
                        placeholder="Enter email address"
                        value={permissionsEmail}
                        onChange={this.handleEmailChange}
                        disabled={isEmailFixed || inviteLoading}
                        isInvalid={!!emailError}
                        style={{ height: '42px' }}
                      />
                      <Button
                        variant="primary"
                        onClick={() => this.handlePortalAction('SEND',isEditingInviteEmail)}
                        disabled={inviteLoading || !permissionsEmail}
                        style={{ whiteSpace: 'nowrap', backgroundColor: '#1b498d', padding: '0 25px' }}
                      >
                        {inviteLoading
                          ? <Spinner as="span" animation="border" size="sm" />
                          : (isEditingInviteEmail ?  inviteStatus === 'accepted' ? 'Update Email' : 'Update email and send invite' : 'Send Invite')}
                      </Button>
                    </div>
                  </Form.Group>
                  {emailError && (
                    <div style={{ color: '#dc3545', fontSize: '13px', marginTop: '4px' }}>
                      {emailError}
                    </div>
                  )}
                </>
              ) : (
                <div className="ml-auto">
                  {inviteStatus === 'invited' && (
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: 'flex-start' }}>
                      <div>
                        <div className={css(styles.statusLabel, styles.pendingStatus)} style={{ marginBottom: '2px' }}>
                          <i className="fa fa-clock-o mr-2" style={{ color: "#ffc107" }}></i> Pending Acceptance
                        </div>
                        {/* Email displayed below the status label */}
                        <div style={{ fontSize: '14px', color: '#666', marginLeft: '24px' }}>
                        <span>{permissionsEmail}</span>
                          <span
                            title="Edit"
                            className={css(
                              styles.imgStyle
                            )}
                            onClick={this.handleEditInviteEmail}
                          >
                            <img
                              alt="edit"
                              className={css(
                                styles.editIconStyle
                              )}
                              src="/images/edit_icn.png"
                            />
                          </span>
                        </div>
                      </div>
                      <Button size="sm" variant="outline-primary" onClick={() => this.handlePortalAction('RESEND')} disabled={inviteLoading} className={css(styles.statusButton)}>
                        {inviteLoading ? <Spinner size="sm" /> : 'Resend Invite'}
                      </Button>
                    </div>
                  )}
                  {inviteStatus === 'invited_expired' && (
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: 'flex-start' }}>
                      <div>
                        <div className={css(styles.statusLabel, styles.pendingStatus)} style={{ marginBottom: '2px' }}>
                          <i className="fa fa-ban mr-2" style={{ color: "red" }}></i> Invite Expired
                        </div>
                        {/* Email displayed below the status label */}
                        <div style={{ fontSize: '14px', color: '#666', marginLeft: '24px' }}>
                        <span>{permissionsEmail}</span>
                          <span
                            title="Edit"
                            className={css(
                              styles.imgStyle
                            )}
                            onClick={this.handleEditInviteEmail}
                          >
                            <img
                              alt="edit"
                              className={css(
                                styles.editIconStyle
                              )}
                              src="/images/edit_icn.png"
                            />
                          </span>
                        </div>
                      </div>
                      <Button size="sm" variant="outline-primary" onClick={() => this.handlePortalAction('RESEND')} disabled={inviteLoading} className={css(styles.statusButton)}>
                        {inviteLoading ? <Spinner size="sm" /> : 'Resend Invite'}
                      </Button>
                    </div>
                  )}
                  {inviteStatus === 'accepted' && (
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: 'flex-start' }}>
                      <div>
                        <div className={css(styles.statusLabel, styles.acceptedStatus)} style={{ marginBottom: '2px' }}>
                          <i className="fa fa-check-circle mr-2" style={{ color: "green" }}></i> Accepted
                        </div>
                        {/* Email displayed below the status label */}
                        <div style={{ fontSize: '14px', color: '#666', marginLeft: '20px',display:'flex',alignItems:'Center'}}>
                          <span>{permissionsEmail}</span>
                          <span
                            title="Edit"
                            className={css(
                              styles.imgStyle
                            )}
                            onClick={this.handleEditInviteEmail}
                          >
                            <img
                              alt="edit"
                              className={css(
                                styles.editIconStyle
                              )}
                              src="/images/edit_icn.png"
                            />
                          </span>
                        </div>
                      </div>
                      <Button size="sm" variant="outline-danger" onClick={() => this.handlePortalAction('REVOKE')} disabled={inviteLoading} className={css(styles.statusButton)}>
                        {inviteLoading ? <Spinner size="sm" /> : 'Revoke Access'}
                      </Button>
                    </div>
                  )}
                  {inviteStatus === 'revoked' && (
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: 'flex-start' }}>
                      <div>
                        <div className={css(styles.statusLabel, styles.revokedStatus)} style={{ marginBottom: '2px' }}>
                          <i className="fa fa-ban mr-2" style={{ color: "red" }}></i> Revoked
                        </div>
                        {/* Email displayed below the status label */}
                        <div style={{ fontSize: '14px', color: '#666', marginLeft: '24px' }}>
                          {permissionsEmail}
                        </div>
                      </div>
                      <Button size="sm" variant="outline-primary" onClick={() => this.handlePortalAction('REINVITE')} disabled={inviteLoading} className={css(styles.statusButton)}>
                        {inviteLoading ? <Spinner size="sm" /> : 'Re-invite'}
                      </Button>
                    </div>
                  )}
                </div>
              )}
          </Modal.Body>
        </Modal>
        <CustomModal
          show={this.state.showAlertPopup}
          modalType='alert'
          title={'Alert'}
          handleClose={this.handleAlertPopup}
          message={`Your current ${this.state.subsPlanName} subscription plan only allows ${this.props.contactAlertLimit} contact to be selected for alerting using SMS/Calls. To add more contacts for sending out alerts, you need to change your plan.`}
        />

        <GenericModal
          header={""}
          name={""}
          size={this.state.customMessage && this.state.customMessage.length > 100 ? "lg" : "sm"}
          title={this.state.customMessage}
          show={this.state.showCustomModal}
          confirmButtons={false}
          action={this.handleCustomModal}
        />

        <NewContactModal
          title={this.state.title}
          modalType={this.state.modalType}
          showNewContactModal={this.state.showNewContactModal}
          contactTypes={this.state.patientContactTypes.filter((val) => { return !val.isSharedContact })}
          close={this.closeNewContactModal}
          handleChange={this.handleChange}
          contactTypeParams={this.state.contactTypeParams}
          formInputs={this.state.formInputs}
          submitContactData={this.submitContactData}
          updateContactData={this.updateContactData}
          setPhoneNumber={this.setPhoneNumber}
          imageArr={this.state.imageArr}
          patientContactId={this.state.patientContactId}
          handleEmergencyCall={this.handleEmergencyCall}
          handleTextMessage={this.handleTextMessage}
          handlePrescriptionMeds={this.handlePrescriptionMeds}
          handleGeoFenceAlert={this.handleGeoFenceAlert}
          handleBatteryPerAlert={this.handleBatteryPerAlert}
          handleContactImage={this.handleContactImage}
          loading={this.state.loading}
          validated={this.state.validated}
          isValidPhone={this.state.isValidPhone}
          appModules={this.props.appModules}
          patientSubscription={this.props.patientSubscription}
          handleSendInviteToggle={this.handleSendInviteToggle}
          isEmailDisabled={this.state.isEmailDisabled}
        />
        <Modal
          show={this.state.showDeleteModal}
          onHide={this.handleDeleteClose}
          backdrop="static"
          keyboard={false}
        >
          {this.state.element}
        </Modal>

        <SideMenuComponentsHeader title={"Contacts"} />
        <div>
          {" "}
          <Row className={css(styles.mainGrid)}>
            <Col xs={12} lg={3} className={`${css(styles.sideStyle)} d-none d-lg-block`}>
              <SideDetails />
            </Col>
            <Col xs={12} lg={9}>
              <div className="patient-contacts-content">
                <div className={css(styles.header)}>
                  <span>{"Contacts"}</span>
                  {this.shouldShowCRUDOptions() && !isReadOnly ?
                    <div>
                      <Button
                        variant="link"
                        title="Add New Contact"
                        onClick={this.addNewContact}
                        className={css(styles.buttonStyle)}
                      >
                        <img src="/images/add_icon_black.png" alt="new" />
                      </Button>
                    </div>
                    :
                    ""
                  }
                </div>
                <div>
                  <Row>{!this.shouldShowCRUDOptions() && <div style={{ color: "red" }}>{"You don't have an active subscription!"}</div>}</Row>
                  <Row>
                    {Object.keys(this.state.typeWiseContacts).length !== 0 &&
                      Object.keys(this.state.typeWiseContacts).map(
                        (contactType) => {
                          if (
                            this.state.typeWiseContacts[contactType].length !==
                            0
                          )
                            return (
                              <Col
                                xs={12}
                                sm={12}
                                md={12}
                                style={{ paddingTop: "1em" }}
                              >
                                <div className={css(styles.cardHeaderStyle)}>
                                  {
                                    this.state.typeWiseContacts[contactType][0]
                                      .contactType.contactType
                                  }
                                </div>
                                <Row>
                                  {this.state.typeWiseContacts[contactType].map(
                                    (contact, index) => {
                                      return (
                                        <Col
                                          xs={12}
                                          sm={6}
                                          xl={4}
                                          className="contact-card-col"
                                          style={{ paddingTop: "1em" }}
                                        >
                                          <Card className="contact-card">
                                            <Card.Header
                                              className={css(
                                                styles.cardSubHeaderStyle
                                              )}
                                            >
                                              {this.shouldShowCRUDOptions(contact.contactType.isSharedContact) && !isReadOnly ?
                                                <div
                                                  className={css(
                                                    styles.imgDivStyle
                                                  )}
                                                >
                                                  {PORTAL_ACCESS_TYPES.includes(contact.contactType.code) && (
                                                    <span
                                                      title="Manage Invitations"
                                                      className={css(
                                                        styles.imgStyle
                                                      )}
                                                      onClick={() =>
                                                        this.handleOpenPermissions(contact)
                                                      }
                                                    >
                                                      <img
                                                        alt="manage invitations"
                                                        className={css(
                                                          styles.editIconStyle
                                                        )}
                                                        src="/images/invitation_3.png"
                                                      />
                                                    </span>
                                                  )}
                                                  <span
                                                    title="Edit"
                                                    className={css(
                                                      styles.imgStyle
                                                    )}
                                                    onClick={() =>
                                                      this.updateContact(contact)
                                                    }
                                                  >
                                                    <img
                                                      alt="edit"
                                                      className={css(
                                                        styles.editIconStyle
                                                      )}
                                                      src="/images/edit_icn.png"
                                                    />
                                                  </span>
                                                  <span
                                                    title="Delete"
                                                    className={css(
                                                      styles.imgStyle
                                                    )}
                                                    onClick={() =>
                                                      this.openDeleteModal(
                                                        contact
                                                      )
                                                    }
                                                  >
                                                    <img
                                                      alt="delete"
                                                      className={css(
                                                        styles.deleteIconStyle
                                                      )}
                                                      src="/images/delete_icon_black.png"
                                                    />
                                                  </span>
                                                </div>
                                                :
                                                <div style={{ height: "28px" }}></div>
                                              }
                                            </Card.Header>

                                            <Card.Body
                                              className={css(styles.cardBody)}
                                            >
                                              {this.state.imageArr.find(
                                                (c) => c.id === contact.id
                                              ) === undefined ? (
                                                <div
                                                  style={{
                                                    paddingRight: "1em",
                                                  }}
                                                >
                                                  <img
                                                    alt="avatar"
                                                    src={"/images/userImg.png"}
                                                    className={css(
                                                      styles.profile
                                                    )}
                                                  />
                                                </div>
                                              ) : (
                                                <div
                                                  style={{
                                                    paddingRight: "1em",
                                                  }}
                                                >
                                                  <img
                                                    alt="avatar"
                                                    src={
                                                      this.state.imageArr.find(
                                                        (c) =>
                                                          c.id === contact.id
                                                      ).path
                                                    }
                                                    className={css(
                                                      styles.profile
                                                    )}
                                                  />
                                                </div>
                                              )}

                                              <div className="contact-card-info">
                                                <Card.Title
                                                  className={css(
                                                    styles.cardBodyTitle
                                                  )}
                                                >
                                                  {contact.firstName}
                                                </Card.Title>
                                                <Card.Text
                                                  className={css(
                                                    styles.cardBodyText
                                                  )}
                                                >
                                                  {contact.phoneNumber !==
                                                    null && (
                                                      <div className="contact-phone-wrapper">
                                                        <PhoneInput
                                                          value={
                                                            contact.phoneNumber
                                                          }
                                                          disabled={true}
                                                          inputClass={"phone-input"}
                                                          buttonClass={
                                                            "phone-button-class"
                                                          }
                                                        />
                                                      </div>
                                                    )}
                                                </Card.Text>
                                              </div>
                                            </Card.Body>
                                          </Card>
                                        </Col>
                                      );
                                    }
                                  )}
                                </Row>
                              </Col>
                            );
                        }
                      )}
                  </Row>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </container>
    );
  }
}

export default connect(
  (store) => {
    return {
      patientData: store?.patientDetails?.patientDetails,
      appModules: store.dashboard.appModules,
      patientSubscription: store.dashboard.patientSubscription,
      contactAlertLimit: store.dashboard.contactAlertLimit,
      user: store.user

      //mobileAppSettingsMasterList: store.dashboard.mobileAppSettingsMasterList,
    };
  },
  (dispatch) => {
    return {
      //   setAbnormalSettingsData: (abnormalMotionSettings) => {
      //     dispatch({
      //       type: "SET_ABNORMAL_MOTION_SETTINGS",
      //       payload: { abnormalMotionSettings },
      //     });
      //   },
    };
  }
)(withRouter(PatientContacts));
